"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.engineEffects = exports.setValueEffect = exports.effectValue = exports.SetValueEffectSpecialValue = void 0;
const t = __importStar(require("typegate"));
const conditions_1 = require("./conditions/conditions");
var SetValueEffectSpecialValue;
(function (SetValueEffectSpecialValue) {
    SetValueEffectSpecialValue["newId"] = "{{new_id}}";
})(SetValueEffectSpecialValue || (exports.SetValueEffectSpecialValue = SetValueEffectSpecialValue = {}));
exports.effectValue = t.union(t.string, t.boolean, t.number, t.lazy(() => conditions_1.query), t.tsEnum(SetValueEffectSpecialValue), t.undefined);
exports.setValueEffect = t
    .object(t.property('at', t.string), t.property('value', exports.effectValue), t.optionalProperty('triggerIf', t.lazy(() => conditions_1.conditions)), t.optionalProperty('newAnswerMustMatch', t.unknown))
    .setTypeName('SetValueEffect');
exports.engineEffects = t
    .object(t.optionalProperty('beforeValueUpdate', t.array(exports.setValueEffect)), t.optionalProperty('afterValueUpdate', t.array(exports.setValueEffect)))
    .setTypeName('EngineEffects');
